import { CircularProgress, Container } from '@mui/material';

export const LoadingPage = () => {

    return (
        <Container
            className="no-scrollbar"
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                overflowY: 'auto'
            }}
        >
            <CircularProgress/>
        </Container>

    );
};